/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoicePaymentsCountDetailDto
 */
export interface InvoicePaymentsCountDetailDto {
    /**
     * 
     * @type {number}
     * @memberof InvoicePaymentsCountDetailDto
     */
    monthly?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePaymentsCountDetailDto
     */
    yearly?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoicePaymentsCountDetailDto
     */
    halfyearly?: number;
}

export function InvoicePaymentsCountDetailDtoFromJSON(json: any): InvoicePaymentsCountDetailDto {
    return InvoicePaymentsCountDetailDtoFromJSONTyped(json, false);
}

export function InvoicePaymentsCountDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoicePaymentsCountDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monthly': !exists(json, 'monthly') ? undefined : json['monthly'],
        'yearly': !exists(json, 'yearly') ? undefined : json['yearly'],
        'halfyearly': !exists(json, 'halfyearly') ? undefined : json['halfyearly'],
    };
}

export function InvoicePaymentsCountDetailDtoToJSON(value?: InvoicePaymentsCountDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monthly': value.monthly,
        'yearly': value.yearly,
        'halfyearly': value.halfyearly,
    };
}

